import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel } from './base-echart-settings.model';
import { AxisTypeEnum, DatosAxisModel, DatosAxisPointer, TextAlignEnum } from './sub-models/datos-axis.model';

export class GeoSettingsModel extends BaseEchartsSettingsModel<GeoSeriesModel> {
  constructor(
    public serieAxis: DatosAxisModel = new DatosAxisModel(null, AxisTypeEnum.value, TextAlignEnum.right),
    series = [],
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    dimensions?: fieldId[],
    breakdowns?: fieldId[],
  ) {
    super(series, show_legend, axisPointer, dimensions, breakdowns);
  }
}

export class GeoSeriesModel {
  constructor(public field_id: fieldId | null = null) {}
}
